import { app } from '../../../bootstrap/core';
import progressBarComponent from './progressBar.component';

app.component('progressBar', progressBarComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/progressBar/progressBar.js